import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { LanguagesService } from 'src/app/services/language.service';
import { BaseService } from 'src/app/services/base.service';

  @Component({
    selector: 'israely-status',
    templateUrl: './israely-status.component.html'
  })
  export class IsraelyStatusComponent implements OnInit {
    @Input() form: FormGroup = null;
    @Input() isForChild = false;
    @Output() onreset = new EventEmitter();
    @Output() statChanged = new EventEmitter<number>();
    
    constructor (public languagesService: LanguagesService,
        public baseService: BaseService) 
    { 
      this.statChanged.subscribe((new_stat)=>{
        this.form.controls.departure_date.setErrors(null)
        this.form.controls.army_service.setErrors(null)
        this.form.controls.content.setErrors(null)
        this.form.controls.departure_date.setValidators(new_stat == "1" ? Validators.required : null);    
        if (!this.isForChild)
          this.form.controls.army_service.setValidators(new_stat == '1' ? 
              Validators.required : null);
      });
    }

    ngOnInit(): void {
        this.form.addControl('israely_status', new FormControl('', [Validators.required]));
        this.form.addControl('departure_date', new FormControl('', []));
        this.form.addControl('army_service', new FormControl('', []));
        this.form.addControl('content', new FormControl('', []));
        this.form.addControl('gov_check', new FormControl(false, []));
    }

    public get f() {
        return this.form.controls;  
    }

    public get v() {
      return this.form.value;  
  }

    onReset() {
        this.onreset.emit();
    }

    statusChanged() {
      this.statChanged.emit(Number(this.form.value.israely_status));
    }

    armyServiceChanged() {
      this.form.controls.content.setErrors(null);
      this.form.controls.content.setValidators(
          (this.form.controls.army_service.value == '1') || (this.form.controls.army_service.value == '5') ? 
          Validators.required : null);
    }
  }